import { createContext } from 'react';

const DetailsContext = createContext();

export default DetailsContext;
